import { memo } from 'react';
import { Offcanvas } from 'react-bootstrap';

interface OffCanvasProps {
  showSide?: boolean;
  children?: React.ReactNode;
  onHide?: () => void;
  onShow?: () => void;
}

const OffCanvasSidebar = memo((props: OffCanvasProps) => {
  const { showSide, children, onHide, onShow } = props;

  return (
    <>
      <Offcanvas scroll={true} style={{ width: '20%' }} show={showSide} onHide={onHide} onShow={onShow}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Search and filter</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="pt-0">{children}</Offcanvas.Body>
      </Offcanvas>
    </>
  );
});

export default OffCanvasSidebar;
